import React from 'react';

const KPICard = ({ title, value, icon: Icon, color = 'primary', subtitle }) => {
  const getColorClasses = () => {
    switch (color) {
      case 'success':
        return 'border-success text-success';
      case 'warning':
        return 'border-warning text-warning';
      case 'danger':
        return 'border-danger text-danger';
      default:
        return 'border-primary text-primary';
    }
  };

  return (
    <div className="card-dark p-6 transition-all duration-300 hover:shadow-dark-lg">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <h3 className="text-dark-text-secondary text-sm font-medium mb-2">
            {title}
          </h3>
          <p className="text-2xl font-bold text-dark-text mb-1">
            {value}
          </p>
          {subtitle && (
            <p className="text-dark-text-secondary text-xs">
              {subtitle}
            </p>
          )}
        </div>
        {Icon && (
          <div className={`p-3 rounded-lg bg-gray-800 border-2 ${getColorClasses()}`}>
            <Icon className="w-6 h-6" />
          </div>
        )}
      </div>
    </div>
  );
};

export default KPICard; 